import { Fragment } from "react";
import { formatTRY } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ChevronDown, ChevronRight, BadgeCheck, Undo2 } from "lucide-react";

const CATEGORY_LABELS = { ev: "Ev", insaat: "İnşaat", ofis: "Ofis", yonetim: "Yönetim" };

export const PayrollRow = ({ row, expanded, onToggle, onPay, onUnpay, busy }) => (
  <Fragment>
    <tr className="hover:bg-slate-50 cursor-pointer" onClick={onToggle} data-testid={`payroll-row-${row.employee_id}`}>
      <td className="p-4 text-slate-400">{expanded ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}</td>
      <td className="p-4 font-semibold text-slate-900">{row.employee_name}</td>
      <td className="p-4 text-right text-slate-700">{row.job_count}</td>
      <td className="p-4 text-right font-bold text-emerald-700" data-testid={`payroll-amount-${row.employee_id}`}>{formatTRY(row.total_payment)}</td>
      <td className="p-4">
        {row.paid
          ? <Badge className="bg-indigo-100 text-indigo-700 hover:bg-indigo-100" data-testid={`payroll-status-${row.employee_id}`}>Ödendi · {new Date(row.paid_at).toLocaleDateString("tr-TR")}</Badge>
          : <Badge variant="outline" className="text-amber-600 border-amber-300" data-testid={`payroll-status-${row.employee_id}`}>Bekliyor</Badge>}
      </td>
      <td className="p-4 text-right" onClick={(e) => e.stopPropagation()}>
        {row.paid
          ? <Button size="sm" variant="ghost" disabled={busy} onClick={onUnpay} data-testid={`payroll-unpay-${row.employee_id}`}><Undo2 className="h-4 w-4 mr-1" /> Geri Al</Button>
          : <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" disabled={busy} onClick={onPay} data-testid={`payroll-pay-${row.employee_id}`}><BadgeCheck className="h-4 w-4 mr-1" /> Hakediş Ödendi</Button>}
      </td>
    </tr>
    {expanded && (
      <tr className="bg-slate-50/60" data-testid={`payroll-details-${row.employee_id}`}>
        <td></td>
        <td colSpan={5} className="p-4 pt-0">
          <table className="w-full text-xs">
            <thead className="text-slate-500 uppercase tracking-wider">
              <tr><th className="text-left py-2">Tarih</th><th className="text-left py-2">İş</th><th className="text-left py-2">Müşteri</th><th className="text-left py-2">Kategori</th><th className="text-right py-2">Hakediş</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {row.jobs.map((j) => (
                <tr key={j.id}>
                  <td className="py-2 font-mono text-slate-600">{new Date(j.date).toLocaleDateString("tr-TR")}</td>
                  <td className="py-2 text-slate-800">{j.title}</td>
                  <td className="py-2 text-slate-600">{j.customer_name || "-"}</td>
                  <td className="py-2 text-slate-600">{CATEGORY_LABELS[j.category] || j.category}</td>
                  <td className="py-2 text-right font-semibold text-slate-800">{formatTRY(j.employee_payment)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </td>
      </tr>
    )}
  </Fragment>
);
